import { useImg } from "@/lib/design";


export const LogoMark = ({ className = "h-9 w-9", glow = false }) => (
  <svg viewBox="0 0 64 64" fill="none" className={className} aria-hidden="true">
    <path d="M14 58V28a18 18 0 0 1 36 0v30" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
    <path d="M32 18v32M24.5 29h15" stroke="#D4AF37" strokeWidth="3.2" strokeLinecap="round" style={glow ? { filter: "drop-shadow(0 0 6px #D4AF37)" } : undefined} />
    <path d="M7 23a13 13 0 0 0 0 20" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" opacity=".7" />
    <path d="M57 23a13 13 0 0 1 0 20" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round" opacity=".7" />
    <path d="M2.5 18a20 20 0 0 0 0 30" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" opacity=".4" />
    <path d="M61.5 18a20 20 0 0 1 0 30" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" opacity=".4" />
    <path d="M10 58h44" stroke="currentColor" strokeWidth="3" strokeLinecap="round" />
  </svg>
);

export const Logo = () => {
  const src = useImg("logo");
  return (
  <span className="flex items-center gap-3 md:gap-4">
    <img src={src} data-ve-img="logo" alt="Awa In Kelet logo" data-testid="site-logo-img" className="h-14 w-14 rounded-full ring-1 ring-[#D4AF37]/50 md:h-[72px] md:w-[72px]" />
    <span className="leading-none">
      <span className="font-display block text-[1.7rem] font-semibold tracking-tight text-[#F4EEE2] md:text-[2.1rem]">Awa In Kelet</span>
      <span className="font-ui mt-1 block text-[11px] uppercase tracking-[0.3em] text-[#D4AF37] md:text-[12.5px]">Radio · Time to Choose</span>
    </span>
  </span>
  );
};
